// extracted by mini-css-extract-plugin
export default {"root":"styles_root__e2BRz","button":"styles_button__7QwJL","tasks":"styles_tasks__y659W","task":"styles_task__p8T3P"};